import React from 'react';
import './TestAnalytics.css';

const AnalyticsCard = ({ title, value, icon }) => {
  return (
    <div className="ta-card">
      <div className="ta-card-header">
        <div className="ta-card-icon">{icon}</div>
        <span>{title}</span>
      </div>
      <div className="ta-card-value">
        {value}
      </div>
    </div>
  );
};

export default AnalyticsCard;
